import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { MAX_LENGTH } from '../../constants';
import { selectInitialMessage, useStaticContext } from './static';

const MessageContext = createContext();

export const MessageContextProvider = ({ children }) => {
    const context = useStaticContext();
    const initialMessage = selectInitialMessage(context);
    const [message, setMessage] = useState(initialMessage);
    const [sentMessageData, setSentMessageData] = React.useState({});

    const clearMessage = () => setMessage(initialMessage);

    const onChange = React.useCallback(
        ({ target: { value } }) => setMessage(value),
        [setMessage]
    );

    const appendToMessage = React.useCallback(
        ({ value, separator = '\n' }) => setMessage((prevMessage) => {
            const newMessage = [prevMessage, value].filter(Boolean).join(separator);

            return newMessage.substring(0, MAX_LENGTH);
        }),
        [setMessage]
    );

    return (
        <MessageContext.Provider value={{
            message,
            onChange,
            appendToMessage,
            sentMessageData,
            setSentMessageData,
            clearMessage
        }}>
            {children}
        </MessageContext.Provider>
    );
};

MessageContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useMessage = () => React.useContext(MessageContext);
